import * as React from 'react'
import { Outlet } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'
import { findPet } from '../../helpers/commandHelper.ts'
import { gibiTheme } from '../../helpers/materialTheme.ts'
import { Toast } from '../common/Toast/Toast.tsx'
import { MenuDrawer } from './drawers/MenuDrawer.tsx'
import { FindDrawer } from './drawers/FindDrawer.tsx'
import { MainMenu } from './menus/MainMenu.tsx'
import { NavBar } from './bars/NavBar.tsx'
import { TapBar } from './bars/TapBar.tsx'
import { IPet } from '../../interfaces/types.ts'
import { FindPetMenu } from './menus/FindPetMenu.tsx'
import './Layout.css'
import { useSnapshot } from 'valtio'
import { controlState } from '../../store/controlState.ts'
import { WebSocket } from '../../webSockets/WebSocket.tsx'
import { ChangePassword } from '../common/ChangePassword/ChangePassword.tsx'
import { useViewTransitionNavigate } from '../../hooks/useViewTransitionNavigate.ts'
import { SwipeBack } from '../common/SwipeBack.tsx'

export const Layout: React.FC = () => {
    const snap = useSnapshot(controlState)
    const selected = snap.currentPage
    const menuOpen = snap.menuOpen
    const findOpen = snap.findOpen
    const changePassword = snap.changePassword
    const navigate = useViewTransitionNavigate().navigate
    const isMobile = snap.isOnMobileDevice

    const menuAction = (page: string, state: any = {}) => {
        controlState.menuOpen = false
        controlState.findOpen = false

        navigate(page, {state: JSON.parse(JSON.stringify(state))})
    }

    const doFind = async (pet: IPet) => {
        await findPet(pet)
    }
    
    const layout = (
        <div className={`wrapper ${isMobile ? 'wrapper-mobile' : 'wrapper-desktop'}`}>
            {isMobile ? <aside>
                <TapBar selected={selected} setSelected={(p: string) => { controlState.currentPage = p }} menuOpen={menuOpen}
                        setMenuOpen={(b: boolean) => { controlState.menuOpen = b }} findOpen={findOpen} setFindOpen={(b: boolean) => { controlState.findOpen = b }}/>
            </aside> : null}
            {!isMobile ? <NavBar selected={selected} setSelected={(p: string) => { controlState.currentPage = p }} findOpen={findOpen} setFindOpen={(b: boolean) => { controlState.findOpen = b }}/>
            : null}
            <main>
                <div className={`${isMobile ? 'wrapper-inner' : 'desktop-wrapper-inner'}`}>
                    <div style={{ viewTransitionName: 'page-content', height: '100%' }}>
                        <Outlet/>
                    </div>
                    <MenuDrawer open={menuOpen} menu={<MainMenu menuAction={menuAction}/>}>
                        <FindDrawer open={findOpen} menu={<FindPetMenu menuAction={doFind}/>}>
                            <div/>
                        </FindDrawer>
                    </MenuDrawer>
                </div>
            </main>
            <WebSocket/>
            <SwipeBack/>
            <ChangePassword open={changePassword} setOpen={(b: boolean) => { controlState.changePassword = b }}/>
        </div>
    )

    return (
        <ThemeProvider theme={gibiTheme}>
            {layout}
            <Toast/>
        </ThemeProvider>
    )
}
